import React from 'react';
import './main.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Section: Logo and Description */}
        <div className="footer-section">
          <div className="footer-logo">
            <span className="logo-icon">⚖️</span>
            <span className="logo-text">GRANITSAINFO.COM – ПРОВЕРКА ЗАПРЕТА И СРОКОВ НА ВЪЕЗД</span>
          </div>
          <p>
           GRANITSAINFO.COM — онлайн-сервис для автоматической проверки наличия запрета на въезд в Российскую Федерацию и Республику Беларусь, с указанием сроков действия (если запрет установлен).
Не является официальным сайтом органов МВД РФ, Погранслужбы или органов миграционного контроля.
          </p>
          <p>Безопасность обработки данных подтверждена стандартами защиты пользовательской информации.</p>
        </div>

        {/* Middle Section: Site Sections */}
        <div className="footer-section">
          <h3>РАЗДЕЛЫ САЙТА</h3>
          <ul>
            <li> Проверить наличие запрета на въезд в РФ и РБ</li>
            <li>Срок действия и основание запрета (если имеется)</li>
            <li>Способы проверки и оплаты</li>
            <li>Контакты</li>
          </ul>
        </div>

        {/* Right Section: Contact Info */}
        <div className="footer-section">
          <p>📩 По всем вопросам:</p>
          <p>info@granitsainfo.com</p>
          <p className="phone">📞 Поддержка онлайн чат с менеджером.</p>
          <div className="app-links">
            <a href="#" className="app-link">📱 Доступна с любого устройства</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>🔐 Ваши персональные данные защищены в соответствии с законодательством о защите информации. Все запросы обрабатываются в зашифрованном виде и не передаются третьим лицам.</p>
        <div className="footer-links">
          <a href="#">ДОГОВОР ОФЕРТЫ</a>
          <a href="#">ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;